/** PURE_IMPORTS_START .._.._Observable,.._.._operator_pairwise PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { pairwise } from '../../operator/pairwise';
Observable.prototype.pairwise = pairwise;
//# sourceMappingURL=pairwise.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/add/operator/pairwise.js
// module id = 694
// module chunks = 0